import React from "react";
import { CoreApp, store } from "./modules";
import { Provider } from "react-redux";

function App() {
  return (
    <React.Suspense>
      <Provider store={store}>
        <CoreApp />
      </Provider>
    </React.Suspense>
  );
}

export default App;
